<template>
    <main role="main" id="main-lesson">
  <div class="tit-page mg-0">
   <div class="container-hts">
    <ul class="bredcumb ul-none">
      <li><h2><a href="javascript:;">Hỏi đáp</a></h2></li>
    </ul> 
   </div>
  </div>
  <div class="bg-tit-hd">illustration</div>
  <div class="container-hts bg-hoidap">
    <div class="row group-tabs">
      <div class="col-md-3 col-sm-12 col-xs-12">
            <div class="search-l">
                <input v-model="keywords" type="text" class="form-control" placeholder="Tìm kiếm">
                <span class="icon-search"><i class="fas fa-search"></i></span>
            </div>
            <select v-model="classId" class="form-control select-l">
                <option value="-1">Lớp - Tất cả</option>
                <option v-for="item of classes" :key="item.Id + '-class'" :value="item.Id">{{ item.ClassName }}</option>
            </select>
            <select v-model="subjectId" class="form-control select-l">
                <option value="-1">Môn - Tất cả</option>
                <option v-for="item of subjects" :key="item.Id + '-subject'" :value="item.Id">{{ item.SubjectName }}</option>
            </select>
      </div>
      <div class="col-md-9 col-sm-12 col-xs-12">
        <p><router-link to="/"><a class="back" href="javascript:;"><i class="fas fa-chevron-left"></i> Trở lại</a></router-link></p>
          <div class="comment-w">
              <div class="user-comment">
                    <img src="./../../../assets/imgs/user.png">
                    <h5>{{user.FullName}}</h5>
                    <p>Vai trò - Học sinh <i class="fas fa-angle-down"></i></p>
                    <div class="clear"></div>
              </div>
              <div id="editor" class="form-group">
                <EditorCK :contentEditor="post.Content" :position="0" :toolbar="toolbar" :editorHeight="editorHeight" />
              </div>
              <div class="modal-comment-f">
                <select v-model="post.ClassId" class="form-control select-l" :class="{ 'is-invalid': submitted && !$v.post.ClassId.isSelected }">
                  <option value="-1">Lớp - Tất cả</option>
                  <option v-for="item of classesPost" :key="item.Id" :value="item.Id">{{ item.ClassName }}</option>
              </select>
              <select v-model="post.SubjectId" class="form-control select-l" :class="{ 'is-invalid': submitted && !$v.post.SubjectId.isSelected }">
                  <option value="-1">Môn - Tất cả</option>
                  <option v-for="item of subjectsPost" :key="item.Id" :value="item.Id">{{ item.SubjectName }}</option>
              </select>
                <button v-on:click="submit()" type="button" class="btn btn-primary">Đăng</button>
                <button v-on:click="cancel()" type="button" class="btn btn-second btn-delete" data-dismiss="modal">Hủy</button>
                <div class="clear"></div>
              </div>
          </div>
          <!-- Modal -->
          <div class="modal fade bd-example-modal-lg" id="popup-ch" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
              <div class="modal-content">
                <div class="user-comment">
                        <img src="./../../../assets/imgs/user.png">
                        <h5>{{user.FullName}}</h5>
                        <p>Vai trò - Học sinh <i class="fas fa-angle-down"></i></p>
                        <div class="clear"></div>
                </div>
                <div id="answer-content" class="form-group modal-ndch">
                    <EditorCK :contentEditor="answerContent" :position="1" :toolbar="toolbar" :editorHeight="editorHeight" />
                </div>
                <div class="modal-comment-f">
                  <button v-on:click="answerQuestion()" type="button" class="btn btn-primary">Đăng</button>
                  <button type="button" class="btn btn-second btn-delete" data-dismiss="modal">Hủy</button>
                  <div class="clear"></div>
                </div>
              </div>
            </div>
          </div>
         <div class="group-tabs">
            <!-- Nav tabs -->
            <ul class="nav nav-tabs tab-bg" role="tablist">
              <li role="presentation"><a href="#cong-dong" aria-controls="home" role="tab" data-toggle="tab" class="active">Cộng đồng</a></li>
              <li role="presentation"><a href="#my-question" aria-controls="messages" role="tab" data-toggle="tab">Câu hỏi của tôi</a></li>
            </ul>    

         <!-- Tab panes -->
          <div class="tab-content">
            <!-- Tab Bai Giang -->
           <div role="tabpanel" class="tab-pane active" id="cong-dong">
              <ul class="comment-ul-1 ul-none">
                  <li class="comment-li-1" v-for="item in dataList" :key="item.Id + '-community'">
                    <div class="box-comment-1">
                      <div class="user-comment">
                        <img src="./../../../assets/imgs/user.png">
                        <h5>{{item.User.FullName}}</h5>
                        <p>{{item.DatePost}}</p>
                        <div class="clear"></div>
                      </div>
                      <span class="tuychon-com"><img src="./../../../assets/imgs/3cham.png"></span>
                      <div class="content-comment" v-html="item.Content"></div>
                      <div class="box-like-com">
                        <span class="num-com">{{item.NumLike}} lượt thích</span>
                        <span class="num-com click-traloi"><a v-on:click.stop="showListAnswer('ds-answer-community-'+ item.Id)" href="javascript:;" class="dis-traloi">{{item.NumAnswer}} câu trả lời</a></span>
                        <span v-on:click.stop="showPopupAnswer(item)" class="click-b-comment com-com traloi-1">Trả lời</span>
                        <span v-on:click.stop="like(item.Id)" class="click-b-comment like-com">Thích</span>
                        <div class="clear"></div>
                      </div>
                    </div>

                    <ul :id="'ds-answer-community-'+ item.Id" class="comment-ul-2 ul-none hiden">
                      <li v-for="answer in item.Children" :key="answer.Id + '-answers-community'">
                        <div class="bg-comment-2">
                          <div class="box-comment-2">
                            <div class="user-comment">
                              <h5>{{answer.User.FullName}}</h5>
                              <p>{{answer.DatePost}}</p>
                              <div class="clear"></div>
                            </div>
                            <span class="tuychon-com"><img src="./../../../assets/imgs/3cham.png"></span>
                             <div class="content-comment" v-html="answer.Content"></div>
                          </div> 
                          <div class="box-like-com">
                              <span class="num-com">{{answer.NumLike}} lượt thích</span>
                              <a v-on:click.stop="showListAnswer('ds-answer-community-2-'+ answer.Id)" href="javascript:;" class="num-com dis-traloi">{{answer.NumAnswer}} câu trả lời</a>
                              <span v-on:click.stop="showPopupAnswer(answer)" class="click-b-comment">Trả lời</span>
                              <span v-on:click.stop="like(answer.Id)" class="click-b-comment">Thích</span>
                              <div class="clear"></div>
                            </div>
                        </div> 
                        <ul :id="'ds-answer-community-2-'+ answer.Id" class="comment-ul-2 comment-ul-n ul-none hiden">
                          <li v-for="child in answer.Children" :key="child.Id + '-answers-community-2'">
                            <div class="bg-comment-2">
                              <div class="box-comment-2">
                                <div class="user-comment">
                                    <h5>{{child.User.FullName}}</h5>
                                    <p>{{child.DatePost}}</p>
                                  <div class="clear"></div>
                                </div>
                                <span class="tuychon-com"><img src="./../../../assets/imgs/3cham.png"></span>
                                <div class="content-comment" v-html="child.Content"></div>
                              </div> 
                              <div class="box-like-com">
                                  <span class="num-com">{{child.NumLike}} lượt thích</span>
                                  <a v-on:click.stop="showListAnswer('ds-answer-community-3-'+ child.Id)" href="javascript:;" class="num-com dis-traloi">{{child.NumAnswer}} câu trả lời</a>
                                  <span v-on:click.stop="showPopupAnswer(child)" class="click-b-comment">Trả lời</span>
                                  <span v-on:click.stop="like(child.Id)" class="click-b-comment">Thích</span>
                                  <div class="clear"></div>
                                </div>
                            </div> 
                            <ul :id="'ds-answer-community-3-'+ child.Id" class="comment-ul-2 comment-ul-n ul-none hiden">
                              <li v-for="c in child.Children" :key="c.Id + '-answers-community-3'">
                                <div class="bg-comment-2">
                                  <div class="box-comment-2">
                                    <div class="user-comment">
                                        <h5>{{c.User.FullName}}</h5>
                                        <p>{{c.DatePost}}</p>
                                      <div class="clear"></div>
                                    </div>
                                    <span class="tuychon-com"><img src="./../../../assets/imgs/3cham.png"></span>
                                    <div class="content-comment" v-html="c.Content"></div>
                                  </div> 
                                  <div class="box-like-com">
                                      <span class="num-com">{{c.NumLike}} lượt thích</span>
                                      <span v-on:click.stop="like(c.Id)" class="click-b-comment">Thích</span>
                                      <div class="clear"></div>
                                    </div>
                                </div> 
                              </li>
                            </ul>
                          </li>
                        </ul>
                       
                      </li>
                    </ul>
                  </li>
                  
                  <div class="comment-load" v-if="loadMore">
                    <span v-on:click="loadMoreData()" class="more-comment more-1"><i class="fas fa-angle-down"></i> Hiển thị thêm</span>
                  </div>
              </ul>
              
            </div>
            <div role="tabpanel" class="tab-pane" id="my-question">
              <ul class="comment-ul-1 ul-none">
                  <li class="comment-li-1" v-for="item in dataOfUser" :key="item.Id + '-my-question'">
                    <div class="box-comment-1">
                      <div class="user-comment">
                        <img src="./../../../assets/imgs/user.png">
                        <h5>{{item.User.FullName}}</h5>
                        <p>{{item.DatePost}}</p>
                        <div class="clear"></div>
                      </div>
                      <span class="tuychon-com"><img src="./../../../assets/imgs/3cham.png"></span>
                      <div class="content-comment" v-html="item.Content"></div>
                      <div class="box-like-com">
                        <span class="num-com">{{item.NumLike}} lượt thích</span>
                        <span class="num-com click-traloi"><a v-on:click.stop="showListAnswer('ds-tra-loi-'+ item.Id)" href="javascript:;" class="dis-traloi">{{item.NumAnswer}} câu trả lời</a></span>
                        <span v-on:click.stop="showPopupAnswer(item)" class="click-b-comment com-com traloi-1">Trả lời</span>
                        <span v-on:click.stop="like(item.Id)" class="click-b-comment like-com">Thích</span>
                        <div class="clear"></div>
                      </div>
                    </div>

                    <ul :id="'ds-tra-loi-'+ item.Id" class="comment-ul-2 ul-none hiden">
                      <li v-for="answer in item.Children" :key="answer.Id + '-answers'">
                        <div class="bg-comment-2">
                          <div class="box-comment-2">
                            <div class="user-comment">
                              <h5>{{answer.User.FullName}}</h5>
                              <p>{{answer.DatePost}}</p>
                              <div class="clear"></div>
                            </div>
                            <span class="tuychon-com"><img src="./../../../assets/imgs/3cham.png"></span>
                            <div class="content-comment" v-html="answer.Content"></div>
                          </div> 
                          <div class="box-like-com">
                              <span class="num-com">{{answer.NumLike}} lượt thích</span>
                              <a v-on:click.stop="showListAnswer('ds-tra-loi-'+ answer.Id)" href="javascript:;" class="num-com dis-traloi">{{answer.NumAnswer}} câu trả lời</a>
                              <span v-on:click.stop="showPopupAnswer(answer)" class="click-b-comment">Trả lời</span>
                              <span v-on:click.stop="like(answer.Id)" class="click-b-comment">Thích</span>
                              <div class="clear"></div>
                            </div>
                        </div> 
                        <ul :id="'ds-tra-loi-'+ answer.Id" class="comment-ul-2 comment-ul-n ul-none hiden">
                          <li v-for="child in answer.Children" :key="child.Id + '-answers'">
                            <div class="bg-comment-2">
                              <div class="box-comment-2">
                                <div class="user-comment">
                                    <h5>{{child.User.FullName}}</h5>
                                    <p>{{child.DatePost}}</p>
                                  <div class="clear"></div>
                                </div>
                                <span class="tuychon-com"><img src="./../../../assets/imgs/3cham.png"></span>
                                <div class="content-comment" v-html="child.Content"></div>
                              </div> 
                              <div class="box-like-com">
                                  <span class="num-com">{{child.NumLike}} lượt thích</span>
                                  <a v-on:click.stop="showListAnswer('ds-tra-loi-'+ child.Id)" href="javascript:;" class="num-com dis-traloi">{{child.NumAnswer}} câu trả lời</a>
                                  <span v-on:click.stop="showPopupAnswer(child)" class="click-b-comment">Trả lời</span>
                                  <span v-on:click.stop="like(child.Id)" class="click-b-comment">Thích</span>
                                  <div class="clear"></div>
                                </div>
                            </div> 
                            <ul :id="'ds-tra-loi-'+ child.Id" class="comment-ul-2 comment-ul-n ul-none hiden">
                              <li v-for="c in child.Children" :key="c.Id + '-answers'">
                                <div class="bg-comment-2">
                                  <div class="box-comment-2">
                                    <div class="user-comment">
                                        <h5>{{c.User.FullName}}</h5>
                                        <p>{{c.DatePost}}</p>
                                      <div class="clear"></div>
                                    </div>
                                    <span class="tuychon-com"><img src="./../../../assets/imgs/3cham.png"></span>
                                    <div class="content-comment" v-html="c.Content"></div>
                                  </div> 
                                  <div class="box-like-com">
                                      <span class="num-com">{{c.NumLike}} lượt thích</span>
                                      <span v-on:click.stop="like(c.Id)" class="click-b-comment">Thích</span>
                                      <div class="clear"></div>
                                    </div>
                                </div> 
                              </li>
                            </ul>
                          </li>
                        </ul>
                       
                      </li>
                    </ul>
                  </li>
                  
                  <div class="comment-load" v-if="loadMoreUser">
                    <span v-on:click="loadMoreDataUser()" class="more-comment more-1"><i class="fas fa-angle-down"></i> Hiển thị thêm</span>
                  </div>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import $ from 'jquery';
    import userService from './../_api/userService';
    import classService from './../_api/classService';
    import subjectService from './../_api/subjectService';
    import questionAnswerService from './../_api/questionAnswerService';
    import EditorCK from '@/components/EditorCK.vue';
    import { required } from "vuelidate/lib/validators";
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import '@ckeditor/ckeditor5-build-classic/build/translations/vi';
    import { CHANGE_TXT_QUESTION } from '@/store/common/constants'
    
    export default {
        name: 'QuestionAnswer',
        data() {
            return {
                loadMore: true,
                loadMoreUser: true,
                submitted: false,
                user: {},
                userId: 1,
                classId: -1,
                subjectId: -1,
                keywords: '',
                pageIndex: 1,
                pageSize: 10,
                pageIndexUser: 1,
                pageSizeUser: 10,
                classes: [],
                subjects: [],
                dataList: [],
                dataOfUser: [],
                classesPost: [],
                subjectsPost: [],
                answerContent: '',
                post: { Id: 0, ParentId: 0, SubjectId: -1, ClassId: -1, Content: ''},
                answer: { Id: 0, ParentId: 0, SubjectId: -1, ClassId: -1},
                toolbar: [
                        { name: 'styles', items: [ 'Format', 'Font', 'FontSize' ] },
                        { name: 'basicstyles', items: [ 'Bold', 'Italic', 'Underline', 'Strike'] },
                        { name: 'colors', items: [ 'TextColor', 'BGColor' ] },
                        { name: 'paragraph', items: [ 'NumberedList', 'BulletedList', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'] },
                        { name: 'insert', items: [ 'Media', 'uploadImg', 'Smiley', 'ckeditor_wiris_formulaEditor','ckeditor_wiris_formulaEditorChemistry' ] },
                ],
                editorHeight: 100
            }
        },
        components: {
          EditorCK
        },
        created() {
            this.$bus.on(`${CHANGE_TXT_QUESTION}_0`, this.handleChangeQuestionContent);
            this.$bus.on(`${CHANGE_TXT_QUESTION}_1`, this.handleChangeAnswerContent);
            this.post.UserId = this.userId;
            this.post.CreatorId = this.userId;
            this.post.UpdateId = this.userId;
            this.answer.UserId = this.userId;
            this.answer.CreatorId = this.userId;
            this.answer.UpdateId = this.userId;
            this.getUser();
            this.getClasses();
            this.getClassesPost();
            this.getData();
            this.getDataOfUser();
        },
        destroyed() {
          this.$bus.off(`${CHANGE_TXT_QUESTION}_0`, this.handleChangeQuestionContent);
          this.$bus.off(`${CHANGE_TXT_QUESTION}_1`, this.handleChangeAnswerContent);
        },
        methods: {
            ...mapActions('common', ['setLoading']),

            handleChangeQuestionContent(data) {
               if(data.html != '<p><br></p>'){
                 this.post.Content = data.html;
                 $('#editor').removeClass('is-invalid');
               }
               else if(this.submitted == true){
                 $('#editor').addClass('is-invalid');
               }
            },

            handleChangeAnswerContent(data) {
               if(data.html != '<p><br></p>'){
                 this.answer.Content = this.answerContent = data.html;
                 $('#answer-content').removeClass('is-invalid');
               }
               else if(this.submitted == true){
                 $('#answer-content').addClass('is-invalid');
               }
            },

            showPopupAnswer(obj){
              this.answerContent = "";
              this.answer.ParentId = obj.Id;
              this.answer.UserId = this.userId;
              this.answer.ClassId = obj.ClassId;
              this.answer.SubjectId = obj.SubjectId;
              this.submitted = false;
              $('#answer-content').removeClass('is-invalid');
              $('#popup-ch').modal();
            },

            showListAnswer(id){
              $('#' + id).show();
            },

            answerQuestion(){
                if(this.answerContent == ''){
                  $('#answer-content').addClass('is-invalid');
                  return;
                }
                this.answer.Content = this.answerContent;

                let self = this;
                self.setLoading(true);
                questionAnswerService.add(this.answer)
                .then((response) => {
                    if(response.data.StatusCode == 1){
                        alert("Thêm mới thành công");
                        this.search();
                        $('#popup-ch').modal('hide');
                    }
                    else{
                        alert("Thêm mới không thành công");
                    }
                }).catch(e => { this.errors.push(e) })
                .finally(() => { self.setLoading(false)});
            },

            cancel(){
              this.post.Content = '';
              this.post.ClassId = -1;
              this.post.SubjectId = -1;
              this.submitted = false;
            },

            submit(){
                this.submitted = true;
                this.$v.$touch();
                
                if(this.post.Content == ''){
                  $('#editor').addClass('is-invalid');
                  return;
                }

                if (this.$v.$invalid) {
                    return;
                }

                let self = this;
                self.setLoading(true);
                questionAnswerService.add(this.post)
                .then((response) => {
                    if(response.data.StatusCode == 1){
                        alert("Thêm mới thành công");
                        this.post.Content = '';
                        this.post.ClassId = -1;
                        this.post.SubjectId = -1;
                        this.submitted = false;
                        this.search();
                    }
                    else{
                        alert("Thêm mới không thành công");
                    }
                }).catch(e => { this.errors.push(e) })
                .finally(() => { self.setLoading(false)});
            },

            like(id){
                questionAnswerService.like(id, this.userId)
                .then((response) => {
                    if(response.data.StatusCode == 1){
                      if(response.data.Message == null){
                        alert("Like thành công");
                      }
                      else{
                        alert("Bạn đã like");
                      }
                    }
                }).catch(e => {
                    console.error(e);
                });
            },

            getUser(){
                userService.getById(this.userId)
                .then((response) => {
                    this.user = response.data.Data;
                }).catch(e => {
                    console.error(e);
                });
            },

            loadMoreDataUser(){
              this.pageIndexUser = this.pageIndexUser + 1;
              this.getDataOfUser();
            },

            loadMoreData(){
              this.pageIndex = this.pageIndex + 1;
              this.getData();
            },

            search(){
              this.loadMore = true;
              this.pageIndex = 1;
              this.dataList = [];
              this.dataOfUser = [];
              this.getData();
              this.getDataOfUser();
            },

            getData(){
              let self = this;
              self.setLoading(true);
              questionAnswerService.filter(this.pageIndex, this.pageSize, -1, this.classId, this.subjectId, this.keywords)
              .then((response) => {
                  this.dataList = this.dataList.concat(response.data.Data.Items);
                  if(this.dataList.length >= response.data.Data.Total){
                    this.loadMore = false;
                  }
                  else{
                    this.loadMore = true;
                  }
              }).catch(e => {
                 console.error(e);
                })
                .finally(() => { self.setLoading(false)});
            },

            getDataOfUser(){
              questionAnswerService.filter(this.pageIndexUser, this.pageSizeUser, this.userId, this.classId, this.subjectId, this.keywords)
              .then((response) => {
                  this.dataOfUser = this.dataOfUser.concat(response.data.Data.Items);
                  if(this.dataOfUser.length >= response.data.Data.Total){
                    this.loadMoreUser = false;
                  }
                  else{
                    this.loadMoreUser = true;
                  }
              }).catch(e => {
                 console.error(e);
                })
                .finally();
            },

            getAnswers(item){
              questionAnswerService.getAnswers(1, 30, item.Id)
              .then((response) => {
                  item.Children = response.data.Data.Items;
              }).catch(e => {
                 console.error(e);
                })
                .finally();
            },

            getClasses(){
              classService.getByUser(this.userId)
              .then((response) => {
                  this.classes = response.data.Data;
              }).catch(e => {
                  this.errors.push(e)
                })
                .finally();
            },
            getSubjects(){
              subjectService.get(this.classId)
              .then((response) => {
                  this.subjects = response.data.Data;
              }).catch(e => {
                  this.errors.push(e)
                })
                .finally();
            },

            getClassesPost(){
              classService.getByUser(this.userId)
              .then((response) => {
                  this.classesPost = response.data.Data;
              }).catch(e => {
                  this.errors.push(e)
                })
                .finally();
            },

            getSubjectsPost(){
              subjectService.get(this.post.ClassId)
              .then((response) => {
                  this.subjectsPost = response.data.Data;
              }).catch(e => {
                  this.errors.push(e)
                })
                .finally();
            },
            
        },
        watch: {
            classId: function (val) {
                this.subjectId = -1;
                this.subjects = [];
                if(this.classId > 0){
                    this.getSubjects();
                }
                this.search();
            },
            subjectId: function (val) {
              this.search();
            },
            keywords: function (val) {
              this.search();
            },
            'post.ClassId': function() {
                this.post.SubjectId = -1;
                if(this.post.ClassId > 0){
                    this.getSubjectsPost();
                }
                else{
                    this.subjectsPost = [];
                } 
            },
            answerContent: function(){
              if(this.answerContent !== ''){
                $('#answer-content').removeClass('is-invalid');
              }
            }
        },
        computed: {
           
        },
        validations: {
            post: {
                ClassId: {
                    required,
                    isSelected(value) {
                    if (value > 0) {
                        return true;
                    }
                    else{
                        return false;
                    }
                    }
                },
                SubjectId: {
                    required,
                    isSelected(value) {
                        if (value > 0) {
                            return true;
                        }
                        else{
                            return false;
                        }
                    }
                }
            }
        },
        mounted(){
        }
    }
</script>